import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomatherancab() {



    const cardData = {




keyword: "Mumbai to Matheran Cab",

headingDescription: "Shreesha Tours & Travels provides comfortable, reliable, and affordable Mumbai to Matheran cab services for families, couples, tourists, senior citizens, and weekend travelers. We offer one-way cabs, round-trip taxi services, same-day return trips, and customized hill station travel packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every travel requirement. With doorstep pickup anywhere in Mumbai, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support, we ensure a safe and comfortable journey to the beautiful hill station of Matheran. Whether you are planning a romantic getaway, family vacation, nature trip, monsoon holiday, or sightseeing tour, Shreesha Tours & Travels offers dependable Mumbai to Matheran cab services with professional drivers, clean vehicles, and personalized travel solutions. Enjoy a peaceful road journey through the scenic Western Ghats and explore Matheran's viewpoints, waterfalls, forests, and heritage attractions with complete travel convenience.",

topPlaces: [
  {
    title: "Charlotte Lake",
    description: "Charlotte Lake is one of Matheran's most beautiful natural attractions, surrounded by lush greenery and peaceful landscapes. It serves as the main source of drinking water for Matheran and is a popular sightseeing spot where visitors enjoy scenic views, bird watching, and relaxing moments near nature."
  },
  {
    title: "Panorama Point",
    description: "Panorama Point is one of the most famous viewpoints in Matheran, offering breathtaking 360-degree views of the Sahyadri mountain ranges, valleys, and sunrise landscapes. It is a favorite destination for photographers, nature lovers, and couples looking for memorable experiences."
  },
  {
    title: "Echo Point",
    description: "Echo Point is a popular attraction in Matheran known for its natural echo effect and beautiful valley views. Visitors enjoy the pleasant climate, scenic surroundings, and fun atmosphere, making it a must-visit location for families and tourists."
  },
  {
    title: "Louisa Point",
    description: "Louisa Point is one of Matheran's most spectacular viewpoints, offering panoramic views of mountains, waterfalls, valleys, and historic forts. During the monsoon season, the lush greenery and misty landscapes create a magical experience for visitors."
  },
  {
    title: "One Tree Hill Point",
    description: "One Tree Hill Point is a unique viewpoint famous for a single tree standing on the hilltop. The location offers beautiful trekking routes, peaceful surroundings, and stunning views of the Western Ghats, making it popular among adventure lovers."
  },
  {
    title: "Monkey Point",
    description: "Monkey Point is a scenic viewpoint in Matheran known for its natural rock formations, valley views, and playful monkeys around the area. It is a popular stop for tourists exploring the hill station and enjoying nature."
  },
  {
    title: "Porcupine Point",
    description: "Porcupine Point, also known as Sunset Point, is famous for spectacular sunset views over the surrounding valleys. The peaceful environment, cool breeze, and beautiful landscapes make it one of the best evening spots in Matheran."
  },
  {
    title: "Chanderi Caves",
    description: "Chanderi Caves are a popular trekking destination near Matheran, known for ancient rock formations, adventurous trails, and panoramic views from the hilltop. It is an excellent destination for trekking enthusiasts and adventure seekers."
  },
  {
    title: "Ambarnath Temple",
    description: "Ambarnath Temple is an ancient Shiva temple located near Matheran, famous for its unique Hemadpanthi architecture and historical importance. The beautifully carved stone structure attracts history lovers, architecture enthusiasts, and devotees."
  },
  {
    title: "Karjat",
    description: "Karjat is a scenic destination near Matheran known for waterfalls, trekking trails, forts, rivers, and adventure activities. Many travelers combine Karjat with Matheran for a refreshing weekend getaway from Mumbai."
  }
],



"services": [
  {
    "name": "Mumbai to Matheran Cab",
    "description": "Book Mumbai to Matheran Cab for safe, comfortable, and reliable hill station travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for family trips, weekend holidays, and sightseeing journeys."
  },
  {
    "name": "Mumbai to Matheran Taxi",
    "description": "Hire Mumbai to Matheran Taxi with experienced drivers, comfortable vehicles, and affordable travel packages for a smooth hill station journey."
  },
  {
    "name": "Mumbai to Matheran Cab Service",
    "description": "Book Mumbai to Matheran Cab Service with doorstep pickup, professional chauffeurs, clean AC vehicles, and flexible travel options."
  },
  {
    "name": "Mumbai to Matheran Taxi Service",
    "description": "Choose Mumbai to Matheran Taxi Service for reliable transportation with transparent pricing and comfortable chauffeur-driven cars."
  },
  {
    "name": "Mumbai to Matheran Cab Booking",
    "description": "Complete Mumbai to Matheran Cab Booking online with quick confirmation and multiple vehicle options according to your travel needs."
  },
  {
    "name": "Mumbai to Matheran Car Rental",
    "description": "Choose Mumbai to Matheran Car Rental with chauffeur-driven vehicles for family vacations, sightseeing, and weekend getaways."
  },
  {
    "name": "Mumbai to Matheran Taxi Fare",
    "description": "Check Mumbai to Matheran Taxi Fare with affordable pricing, transparent charges, and comfortable cab options."
  },
  {
    "name": "Mumbai to Matheran Cab Fare",
    "description": "Get Mumbai to Matheran Cab Fare with competitive packages for one way and round trip journeys."
  },
  {
    "name": "Mumbai to Matheran One Way Cab",
    "description": "Book Mumbai to Matheran One Way Cab for economical single-trip travel with professional drivers and fixed pricing options."
  },
  {
    "name": "Mumbai to Matheran Round Trip Taxi",
    "description": "Reserve Mumbai to Matheran Round Trip Taxi for convenient return travel with flexible schedules and affordable packages."
  },
  {
    "name": "Mumbai to Matheran Outstation Cab",
    "description": "Hire Mumbai to Matheran Outstation Cab with experienced chauffeurs and comfortable AC vehicles for long-distance travel."
  },
  {
    "name": "Mumbai Airport to Matheran Cab",
    "description": "Book Mumbai Airport to Matheran Cab with timely airport pickup, professional drivers, and hassle-free hill station transportation."
  },
  {
    "name": "Navi Mumbai to Matheran Cab",
    "description": "Reserve Navi Mumbai to Matheran Cab with reliable drivers, clean vehicles, and affordable travel solutions."
  },
  {
    "name": "Thane to Matheran Taxi",
    "description": "Choose Thane to Matheran Taxi for comfortable travel with experienced chauffeurs and premium vehicle options."
  },
  {
    "name": "Panvel to Matheran Cab",
    "description": "Book Panvel to Matheran Cab with flexible pickup options and smooth transportation for your journey."
  },
  {
    "name": "Mumbai to Matheran Tourist Cab",
    "description": "Hire Mumbai to Matheran Tourist Cab for sightseeing trips with customized travel plans and professional drivers."
  },
  {
    "name": "Mumbai to Matheran Hill Station Taxi",
    "description": "Book Mumbai to Matheran Hill Station Taxi for a comfortable ride to one of Maharashtra's popular hill destinations."
  },
  {
    "name": "Mumbai to Matheran Family Trip Cab",
    "description": "Choose Mumbai to Matheran Family Trip Cab with spacious vehicles and safe travel options for family vacations."
  },
  {
    "name": "Mumbai to Matheran Weekend Trip Cab",
    "description": "Reserve Mumbai to Matheran Weekend Trip Cab for relaxing weekend getaways with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Matheran Innova Cab",
    "description": "Book Mumbai to Matheran Innova Cab for spacious family travel with comfortable seating and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Matheran Innova Crysta Cab",
    "description": "Choose Mumbai to Matheran Innova Crysta Cab for premium travel with luxury interiors and extra luggage space."
  },
  {
    "name": "Mumbai to Matheran Ertiga Cab",
    "description": "Reserve Mumbai to Matheran Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors."
  },
  {
    "name": "Mumbai to Matheran Sedan Cab",
    "description": "Book Mumbai to Matheran Sedan Cab for economical and comfortable travel with clean AC vehicles."
  },
  {
    "name": "Mumbai to Matheran SUV Cab",
    "description": "Hire Mumbai to Matheran SUV Cab with spacious seating and premium comfort for family and group journeys."
  },
  {
    "name": "Best Mumbai to Matheran Cab Booking",
    "description": "Choose Best Mumbai to Matheran Cab Booking service with professional drivers, quality vehicles, affordable fares, and reliable customer support."
  }
],
"tableData": [
  ["Mumbai to Matheran Cab", "Mumbai to Matheran Taxi"],
  ["Mumbai to Matheran Cab Service", "Mumbai to Matheran Taxi Service"],
  ["Mumbai to Matheran Cab Booking", "Mumbai to Matheran Car Rental"],
  ["Mumbai to Matheran Taxi Fare", "Mumbai to Matheran Cab Fare"],
  ["Mumbai to Matheran One Way Cab", "Mumbai to Matheran Round Trip Taxi"],
  ["Mumbai to Matheran Outstation Cab", "Mumbai Airport to Matheran Cab"],
  ["Navi Mumbai to Matheran Cab", "Thane to Matheran Taxi"],
  ["Panvel to Matheran Cab", "Mumbai to Matheran Tourist Cab"],
  ["Mumbai to Matheran Hill Station Taxi", "Mumbai to Matheran Family Trip Cab"],
  ["Mumbai to Matheran Weekend Trip Cab", "Mumbai to Matheran Innova Cab"],
  ["Mumbai to Matheran Innova Crysta Cab", "Mumbai to Matheran Ertiga Cab"],
  ["Mumbai to Matheran Sedan Cab", "Mumbai to Matheran SUV Cab"],
  ["Best Mumbai to Matheran Cab Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Enjoy a Relaxing Mumbai to Matheran Cab Journey",
    WhyChoosedescription: "Shreesha Tours & Travels offers comfortable Mumbai to Matheran cab services for travellers looking for a peaceful hill station getaway with safe transportation, experienced drivers, and convenient travel arrangements."
  },
  {
    WhyChooseheading: "Private Taxi for Scenic Hill Travel",
    WhyChoosedescription: "Avoid crowded transport and enjoy a private ride from Mumbai to Matheran with doorstep pickup and a comfortable journey through scenic routes."
  },
  {
    WhyChooseheading: "Suitable Cars for Couples, Families & Groups",
    WhyChoosedescription: "From Sedan cars for couples to Ertiga, Innova, Innova Crysta, and Tempo Traveller options for groups, select a vehicle that matches your travel needs."
  },
  {
    WhyChooseheading: "Flexible Pickup Locations in Mumbai",
    WhyChoosedescription: "Get pickup from your preferred location including home, hotel, railway station, airport area, or office and travel directly towards Matheran."
  },
  {
    WhyChooseheading: "Experienced Drivers for Ghat Routes",
    WhyChoosedescription: "Our professional chauffeurs understand hill routes and provide a safe, smooth, and comfortable driving experience throughout your Mumbai to Matheran trip."
  },
  {
    WhyChooseheading: "Ideal for Weekend & Nature Holidays",
    WhyChoosedescription: "Plan a refreshing break at Matheran with a private cab suitable for weekend vacations, family outings, romantic getaways, and nature lovers."
  },
  {
    WhyChooseheading: "Customize Your Matheran Travel Plan",
    WhyChoosedescription: "Add nearby attractions and sightseeing stops around Matheran according to your schedule and create a personalized travel experience."
  },
  {
    WhyChooseheading: "Trusted Cab Support from Shreesha Tours & Travels",
    WhyChoosedescription: "Get easy cab availability, transparent pricing, and travel assistance for a smooth Mumbai to Matheran taxi booking experience."
  }
]

};

const faqData = [
  {
    question: "What makes Mumbai to Matheran cab travel a convenient option?",
    answer: "A private cab provides comfortable door-to-door travel from Mumbai to Matheran without the inconvenience of multiple transport changes."
  },
  {
    question: "Can I hire a private taxi for a Matheran weekend trip?",
    answer: "Yes, private taxis are available for weekend holidays, family outings, couples trips, and customized Matheran tours."
  },
  {
    question: "Which cars can I choose for Mumbai to Matheran travel?",
    answer: "You can select Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options based on your group size."
  },
  {
    question: "Is Matheran cab service suitable for senior citizens?",
    answer: "Yes, comfortable vehicles with experienced drivers make the journey convenient for senior citizens and family travellers."
  },
  {
    question: "Can I book a return taxi from Matheran to Mumbai?",
    answer: "Yes, return journey cab options are available according to your preferred date and travel schedule."
  },
  {
    question: "Can sightseeing be included during the Matheran trip?",
    answer: "Yes, sightseeing plans can be customized according to your interests and available travel time."
  },
  {
    question: "Do you provide pickup from Mumbai Airport or railway station?",
    answer: "Yes, pickup facilities are available from Mumbai Airport, railway stations, hotels, homes, offices, and other locations."
  },
  {
    question: "Are Mumbai to Matheran cabs available for group travel?",
    answer: "Yes, spacious vehicles like Ertiga, Innova, Innova Crysta, and Tempo Traveller are available for group journeys."
  },
  {
    question: "Can I book Mumbai to Matheran taxi service for one way?",
    answer: "Yes, one-way taxi booking options are available for travellers who require direct transportation."
  },
  {
    question: "How do I reserve a Mumbai to Matheran Cab with Shreesha Tours & Travels?",
    answer: "Share your travel date, pickup location, passenger count, and preferred vehicle type to get cab details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya More",
    feedback: "The Mumbai to Matheran cab service was very comfortable. The driver was experienced on hill roads, and the vehicle was clean and perfect for our family trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback: "We enjoyed a wonderful weekend trip to Matheran with Shreesha Tours & Travels. The booking process was simple, and the entire journey was smooth and relaxing.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Matheran Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-matheran-cab.webp",
  "description":
    "Book Mumbai to Matheran Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Matheran with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for hill station trips, family vacations, weekend getaways, sightseeing, and corporate travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-matheran-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Matheran Cab | Hill Station Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Matheran Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Matheran with 24x7 online cab booking and experienced drivers."
  />

  <meta
    name="keywords"
    content="Mumbai to Matheran Cab, Mumbai to Matheran Taxi, Mumbai to Matheran Cab Service, Mumbai to Matheran Taxi Service, Mumbai to Matheran Cab Booking, Mumbai to Matheran Car Rental, Mumbai to Matheran Taxi Fare, Mumbai to Matheran Cab Fare, Mumbai to Matheran One Way Cab, Mumbai to Matheran Round Trip Taxi, Mumbai to Matheran Outstation Cab, Mumbai to Matheran Taxi Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitomatherancab;